import {FC, ReactElement} from 'react';
import {ColumnsType} from "antd/lib/table";
import isNumeric from "antd/lib/_util/isNumeric";
import {Card, Table, Typography} from "antd";
import {Props as SectionPerformanceProps} from "./SectionPerformanceCard";
import {FeedbackRowProps} from "../../ActivityFeedbackRows/types";
import {SectionFirstBestDatum} from "./sectionPerformanceUtils";
import {useSectionPerformanceFirstBestData} from "./useSectionPerformanceFirstBestData";
const {Text} = Typography;

interface Props extends Pick<FeedbackRowProps, 'attemptId' | 'activityId'> {
    title: React.ReactNode;
    type: SectionPerformanceProps['type'];
    defaultFilters?: { [key: string]: (string | number | string[] | number []) };
    isAggregated: boolean;
}

const columns = (isAggregated: boolean): ColumnsType<SectionFirstBestDatum> => [
    {
        title: 'Section',
        dataIndex: 'title',
        key: 'title',
        width: '65%'
    },
    {
        title: 'Best',
        dataIndex: 'best_score',
        key: 'best_score',
        width: '8 rem',
        render: (value, record) => {
            return isNumeric(value) ? `${value}%` : 'N/A';
        },
    },
    {
        title: 'First',
        dataIndex: 'first_score',
        key: 'first_score',
        width: '8 rem',
        render: (value, record) => {
            return isNumeric(value) ? `${value}%` : 'N/A';
        },
    },
    {
        title: 'Improved',
        key: 'improvement',
        width: '8 rem',
        render: (_, record) => {
            const firstScore = isNumeric(record.first_score) ? Number(record.first_score) : null;
            const bestScore = isNumeric(record.best_score) ? Number(record.best_score) : null;
            if (firstScore === null || bestScore === null) return 'N/A';
            const improvement = bestScore - firstScore;
            if (improvement <= 0) return '—';
            return <Text style={{fontSize: '1rem', fontWeight: 'bold'}} type='success'>▲ {improvement}%</Text>;
        },
    },
];

export const SectionPerformanceFirstBestTableCard: FC<Props> = ({
    title,
    type,
    attemptId,
    activityId,
    defaultFilters,
    isAggregated,
}): ReactElement => {
    const {mergedRows: tableData, isLoading} = useSectionPerformanceFirstBestData({
        type,
        activityId,
        attemptId,
        defaultFilters,
    });

    return (
        <Card title={title} className='data-table-card card-header-options'>
            <Table
                size='middle'
                rowKey='title'
                pagination={false}
                loading={isLoading}
                dataSource={tableData}
                scroll={{y: 425}}
                columns={columns(isAggregated)}
            />
        </Card>
    );
};
